import isEqual from 'lodash/isEqual'
import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../../../constants/common'
import { REG_EXP_EMAIL } from '../../../../../constants/regExp'
import { getItemsIds } from '../../../../../utils/common'
import { formValidationSchemaNoChanged } from '../../../../Form'
import {
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_COMMENT,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_HAS_INVALID_INPUT,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_IS_INVITATION,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
} from '../RequestProfileWidgetSideWorkers.constants'

import {
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_INVALID_EMAIL_KEY,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_NO_INVALID_INPUT_TEST_NAME,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_VALID_EMAIL_TEST_NAME,
} from './RequestProfileWidgetSideWorkersForm.constants'

function isRequestProfileWidgetSideWorkersFormEqual({ initialValues, values }) {
  if (values[REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_IS_INVITATION]) {
    return false
  }

  return isEqual(
    getItemsIds(
      values[REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS] ??
        EMPTY_LIST,
      'value'
    ),
    getItemsIds(
      initialValues[
        REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS
      ] ?? EMPTY_LIST,
      'value'
    )
  )
}

export function isRequestProfileWidgetSideWorkersValid(items = EMPTY_LIST) {
  return items.every(
    item => !item.isNewWorkerEmail || REG_EXP_EMAIL.test(item.value)
  )
}

export function getRequestProfileWidgetSideWorkersFormValidationSchema(
  initialValues,
  t
) {
  return Yup.object({
    [REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_COMMENT]: Yup.string(),
    [REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_HAS_INVALID_INPUT]:
      Yup.boolean(),
    [REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_IS_INVITATION]:
      Yup.boolean(),
    [REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS]: Yup.array()
      .of(Yup.object())
      .test({
        message: t(REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_INVALID_EMAIL_KEY),
        name: REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_VALID_EMAIL_TEST_NAME,
        test: isRequestProfileWidgetSideWorkersValid,
      }),
  })
    .test({
      name: REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_NO_INVALID_INPUT_TEST_NAME,
      test: function (values) {
        if (
          !values?.[
            REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_HAS_INVALID_INPUT
          ]
        ) {
          return true
        }

        return this.createError({
          message: t(
            REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_INVALID_EMAIL_KEY
          ),
          path: REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
        })
      },
    })
    .concat(
      formValidationSchemaNoChanged({
        initialValues,
        isEqual: isRequestProfileWidgetSideWorkersFormEqual,
      })
    )
}
